import { Icon } from "semantic-ui-react";

import { Dropdown, useCan } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES, QUESTION_RESULT_STATUSES } from "models";
import { QuestionResultStatus } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components";
import { useQuestionResultMutation } from "modules/AppointmentDetails/hooks";

import type { DropdownItemProps } from "components";
import type { Intervention, QuestionResult } from "models";

const options: DropdownItemProps[] = [
  { key: QUESTION_RESULT_STATUSES.OK, icon: <QuestionResultStatus status={QUESTION_RESULT_STATUSES.OK} />, value: QUESTION_RESULT_STATUSES.OK },
  {
    key: QUESTION_RESULT_STATUSES.OKWithRemarks,
    icon: <QuestionResultStatus status={QUESTION_RESULT_STATUSES.OKWithRemarks} />,
    value: QUESTION_RESULT_STATUSES.OKWithRemarks
  },
  { key: QUESTION_RESULT_STATUSES.Advice, icon: <QuestionResultStatus status={QUESTION_RESULT_STATUSES.Advice} />, value: QUESTION_RESULT_STATUSES.Advice },
  { key: QUESTION_RESULT_STATUSES.Necessary, icon: <QuestionResultStatus status={QUESTION_RESULT_STATUSES.Necessary} />, value: QUESTION_RESULT_STATUSES.Necessary },
  { key: QUESTION_RESULT_STATUSES.NVT, icon: <QuestionResultStatus status={QUESTION_RESULT_STATUSES.NVT} />, value: QUESTION_RESULT_STATUSES.NVT }
];

type QuestionResultStatusSelectorProps = {
  questionResult?: QuestionResult;
  intervention?: Intervention;
  disabled?: boolean;
};

export const QuestionResultStatusSelector = ({ questionResult, intervention, disabled }: QuestionResultStatusSelectorProps) => {
  const questionResultMutation = useQuestionResultMutation();
  const canUpdateQuestionResults = useCan(ACL_ACTIVITIES.Update, ACL_RESOURCES.CarCheckQuestionResults);

  const handleUpdate = (status?: number) => {
    if (status === undefined) return;

    if (questionResult) questionResultMutation.mutate({ ...questionResult, status });
  };

  const status = intervention ? intervention.question_result_status : questionResult?.status;
  if (status === undefined || status === QUESTION_RESULT_STATUSES.NoStatus) return null;

  if (disabled || !canUpdateQuestionResults)
    return (
      <div className="view-only">
        <QuestionResultStatus status={status} />
      </div>
    );

  return (
    <Dropdown
      className="status-dropdown"
      options={options}
      onChange={handleUpdate}
      icon={null}
      selectOnBlur={false}
      trigger={
        <div>
          <QuestionResultStatus status={status} />
          <Icon className="ml-025 caret down grey" size="tiny" />
        </div>
      }
    />
  );
};
